export default "__VITE_ASSET__CMW7VBFt__"